import { render, staticRenderFns } from "./delivery-supplement.vue?vue&type=template&id=f28544cc&scoped=true&"
import script from "./delivery-supplement.vue?vue&type=script&lang=js&"
export * from "./delivery-supplement.vue?vue&type=script&lang=js&"
import style0 from "./delivery-supplement.vue?vue&type=style&index=0&id=f28544cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28544cc",
  null
  
)

export default component.exports